import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Animation.scss'


class Animation extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string.isRequired,
    fallbackDuration: PropTypes.number,
    alt: PropTypes.string,
    loop: PropTypes.bool,
    autoPlay: PropTypes.bool,
    isTimeoutEnabled: PropTypes.bool,
    onEnded: PropTypes.func,
  }

  static defaultProps = {
    loop: true,
    autoPlay: true,
  }

  // escape double hanlde if some browser will fire both 'pause' and 'end' events
  isVideoEndHandled = false

  constructor(props) {
    super()

    let isVideoPlayable = false

    const video = document.createElement('video')

    if (video.canPlayType && video.canPlayType('video/mp4').replace(/no/, '')) {
      isVideoPlayable = true
    }

    this.state = {
      isVideoPlayable,
    }
  }

  componentDidMount() {
    const { isVideoPlayable } = this.state

    if (!isVideoPlayable) {
      this.handleGifEnd()
    }
  }

  componentDidUpdate(prevProps, { isVideoPlayable: wasVideoPlayable }) {
    const { isVideoPlayable } = this.state

    if (wasVideoPlayable && !isVideoPlayable) {
      this.handleGifEnd()
    }
  }

  handleGifEnd = () => {
    // TODO @vkudla change isTimeoutEnabled to onloadedmetadata handler
    const { onEnded, fallbackDuration, isTimeoutEnabled } = this.props

    if (typeof onEnded === 'function' || isTimeoutEnabled) {
      setTimeout(onEnded, fallbackDuration)
    }
  }

  handleOnEnded = ({ target: { currentTime, duration } }) => {
    const { onEnded } = this.props

    const isEnded  = duration <= currentTime

    if (!this.isVideoEndHandled && isEnded && typeof onEnded === 'function') {
      this.isVideoEndHandled = true

      onEnded()
    }
  }

  play = (node) => {
    const { autoPlay } = this.props

    if (!node || !autoPlay) {
      return
    }

    const playPromise = node.play()

    if (playPromise) {
      playPromise.catch(() => {
        this.setState({
          isVideoPlayable: false,
        })
      })
    }
  }

  render() {
    const { isVideoPlayable } = this.state
    const { className, src, fallbackSrc, loop, autoPlay, alt } = this.props

    let animationNode = (
      <img className={s.gif} src={fallbackSrc} alt={alt} />
    )

    if (isVideoPlayable) {
      animationNode = (
        <video
          ref={this.play}
          className={s.video}
          loop={loop}
          autoPlay={autoPlay}
          onPause={this.handleOnEnded}
          onEnded={this.handleOnEnded}
          aria-label={alt}
          controls={false}
          muted
          playsInline
        >
          <source src={src} type="video/mp4" />
        </video>
      )
    }

    return (
      <div className={cx(s.animation, className)}>
        {animationNode}
      </div>
    )
  }
}


export default Animation
